import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkAccess(state.url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkAccess(state.url);
  }

  private async checkAccess(url: string): Promise<boolean | UrlTree> {
    if (await this.authService.restoreSession()) {
      return true;
    }

    sessionStorage.setItem('postLoginRedirectUrl', url);
    // Clear only this tab's tokens: ending the OneLogin session here would log out every other open tab
    this.authService.getOAuthService().logOut(true);
    return this.router.parseUrl('/login');
  }
}
